import type { UnknownEnum } from './unknown-value.interface';

export enum BatteryHealth {
  UNSPECIFIED = 'UNSPECIFIED',
  NORMAL = 'NORMAL',
  SOON = 'SOON',
  NOW = 'NOW',
}

export type BatteryHealthOrUnknown = BatteryHealth | UnknownEnum;